import { useCartContext } from "@/src/context/CartContext";
import { HeroSection } from "./(sections)/hero/HeroSection";
import { ProductGrid } from "./(sections)/products/ProductGrid";
import { BrandStory } from "./(sections)/brand/BrandStory";
import { Newsletter } from "./(sections)/newsletter/Newsletter";

export function HomePage() {
    const { addToCart } = useCartContext();

    return (
        <>
            <HeroSection />
            <ProductGrid onAddToCart={addToCart} />
            <BrandStory />
            <Newsletter />
        </>
    );
}
